import { wagmiConfig } from '@/config/wagmi-config'
import { useMemo } from 'react'
import { abi as survey4Abi } from '@/abi/Survey4'
import { makeWriteContractAsync } from '@/utils/wagmi/makeOperations'

export function useWriteSurvey4Contract(surveyAddress) {
	return useMemo(
		() => makeWriteContractAsync(wagmiConfig, { abi: survey4Abi, address: surveyAddress }),
		[surveyAddress]
	)
}
